import { AppBar, Toolbar, Box } from "@mui/material";
import DesktopNavLinks from "./DesktopNavLinks/DesktopNavLinks";
import MobileNavLinks from "./MobileNavLinks/MobileNavLinks";
import DarkModeSwitcher from "./DarkModeSwitcher";
import routingObject from "../routingObject";

const Navbar = () => {
  const navRoutesArray = Object.values(routingObject).filter(
    // filtering out routes that we don't want in the navbar -- hiring subpages if relevant, french form, etc
    ({ redactFromNav }) => redactFromNav !== true
  );

  return (
    <AppBar
      position="sticky"
      // this property is set to "false" by default, which greys out the appbar rather than applying the default "primary" color (in dark mode, light blue). this is arguably unideal in that it makes the appbar bright blue which goes against dark mode philosophy, BUT it allows is to have our text have the color "primary.contrastText" (ln 27), which automatically contrasts it against the appbar in either mode
      enableColorOnDark
    >
      <Toolbar>
        <Box sx={{ flexGrow: 1 }}>
          <DesktopNavLinks navRoutesArray={navRoutesArray} />
          <MobileNavLinks navRoutesArray={navRoutesArray} />
        </Box>
        <DarkModeSwitcher />
      </Toolbar>
    </AppBar>
  );
};
export default Navbar;
